import { useState } from "react";
import { Coins } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { BuyCreditsModal } from "./BuyCreditsModal";

export function CreditsBadge() {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);

  if (!user || user.role !== "Manager") return null;

  const credits = user.credits ?? 0;

  const isLow = credits <= 2;

  const colorClass =
    credits <= 0
      ? "text-red-500 bg-red-500/10 border-red-500/20"
      : credits < 10
        ? "text-yellow-500 bg-yellow-500/10 border-yellow-500/20"
        : "text-easly-emerald bg-easly-emerald/10 border-easly-emerald/20";

  return (
    <>
      <button
        type="button"
        onClick={() => user.hasPremium && setOpen(true)}
        title={user.hasPremium ? "Buy more credits" : "Upgrade to premium to buy credits"}
        className={`flex items-center gap-1.5 rounded-lg border px-2 py-1 text-xs font-medium transition-colors ${colorClass} ${
          user.hasPremium ? "cursor-pointer hover:opacity-80" : "cursor-default"
        } ${isLow ? "animate-pulse" : ""}`}
      >
        <Coins className="w-3.5 h-3.5" />
        {credits} credits
      </button>

      <BuyCreditsModal open={open} onOpenChange={setOpen} />
    </>
  );
}
